import { useCallback, useState } from 'react';
import type { Period } from '@casetrace/shared';

export function useCaseStoryPanels() {
  const [periodsPanelOpen, setPeriodsPanelOpen] = useState(false);
  const [editingPeriod, setEditingPeriod] = useState<Period | null | undefined>(undefined);

  const openCreatePeriod = useCallback(() => {
    setEditingPeriod(null);
  }, []);

  const openEditPeriod = useCallback((period: Period) => {
    setEditingPeriod(period);
    setPeriodsPanelOpen(false);
  }, []);

  const closePeriodEditor = useCallback(() => {
    setEditingPeriod(undefined);
  }, []);

  const openPeriodsPanel = useCallback(() => setPeriodsPanelOpen(true), []);
  const closePeriodsPanel = useCallback(() => setPeriodsPanelOpen(false), []);

  const periodEditorOpen = editingPeriod !== undefined;

  return {
    periodsPanelOpen,
    periodEditorOpen,
    editingPeriod: editingPeriod ?? null,
    openCreatePeriod,
    openEditPeriod,
    closePeriodEditor,
    openPeriodsPanel,
    closePeriodsPanel,
  };
}
